import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

/** Downloads a listing's remote logo/cover into our own storage. */
export const mirrorListingMedia = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((data: { listingId: string }) => {
    const listingId = String(data?.listingId ?? "").trim();
    if (!listingId) throw new Error("A listing id is required.");
    return { listingId };
  })
  .handler(async ({ data }) => {
    const { mirrorListingImages } = await import("./listing-media.server");
    await mirrorListingImages(data.listingId);
    return { ok: true };
  });
